module.exports = __webpack_public_path__ + "img/gc_white.e6ab36a3.png";